module.exports = __webpack_public_path__ + "static/media/record.313daae0.png";